import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Import Common CSS here!
import './Common.css';

// Import all sub-components
import Toolbar from './Toolbar';
import Breadcrumb from './Breadcrumb';
import FolderGrid from './FolderGrid';
import ModuleList from './ModuleList';
import CommandPalette from './CommandPalette';
import LoadMoreButton from './LoadMoreButton';
import Skeleton from './Skeleton';

// Import Hook
import { useBloggerApi } from '../../hooks/useBloggerApi';

export default function PracticeTestWrapper() {
  const navigate = useNavigate();
  const [commandPaletteOpen, setCommandPaletteOpen] = useState(false);
  
  const [currentView, setCurrentView] = useState("folders"); 
  const [activeCategory, setActiveCategory] = useState(null);

  const { posts, loading, fullyCached, fetchMore, syncData } = useBloggerApi();

  const handleFolderClick = (category) => {
    setActiveCategory(category);
    setCurrentView("posts");
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleBackToFolders = () => {
    if (currentView === "posts") {
      setActiveCategory(null);
      setCurrentView("folders");
    } else {
      navigate('/users');
    }
  };

  return (
    <div className="practice-test-wrapper">
      <Toolbar 
        onOpenSearch={() => setCommandPaletteOpen(true)}
        onSync={syncData}
        isSyncing={loading}
      />
      
      <Breadcrumb 
        currentView={currentView}
        activeCategory={activeCategory}
        onBack={handleBackToFolders}
      />

      {loading && posts.length === 0 ? (
        <Skeleton count={3} />
      ) : (
        <div id="dynamicContainer" className="dynamic-container">
          {currentView === "folders" && (
            <FolderGrid posts={posts} onFolderClick={handleFolderClick} />
          )}
          
          {currentView === "posts" && (
            <ModuleList posts={posts} category={activeCategory} />
          )}
        </div>
      )}

      {currentView === "posts" && !fullyCached && (
        <LoadMoreButton onClick={fetchMore} loading={loading} />
      )}

      <CommandPalette 
        open={commandPaletteOpen} 
        onClose={() => setCommandPaletteOpen(false)}
        posts={posts}
      />
    </div>
  );
}